export const translations = {
  en: {
    // Navigation
    nav: {
      work: 'work',
      about: 'about',
      press: 'press',
      contact: 'contact'
    },
    
    // Home
    home: {
      tagline: 'from element to experience',
      statement: {
        line1: 'We design for people who aren\'t afraid of a space with opinions.',
        line2: 'The feeling it gives you — that\'s the design.',
        line3: 'Everything else is execution.',
        line4: 'Sofia · Milano · across Europe.'
      },
      disciplines: {
        residential: 'residential',
        residentialDesc: 'Apartments, homes and private spaces with a clear point of view.',
        hospitality: 'hospitality',
        hospitalityDesc: 'Hotels, restaurants, bars and offices people actually want to be in.',
        commercial: 'commercial',
        commercialDesc: 'Offices, showrooms and retail spaces designed for the people who work and move through them every day.',
        identity: 'visual identity',
        identityDesc: 'Brand systems that speak the same language as the space.'
      },
      projectIncludes: {
        title: 'What a project includes',
        intro1: 'We work from the first conversation to the last detail.',
        intro2: 'Every project — regardless of type — is taken through the full process:',
        services: 'Brief & concept development · Spatial planning · 3D visualisation · Material, furniture & lighting selection · Technical documentation · Author\'s supervision on site',
        closing: 'No handoffs. No loose ends.'
      },
      cta: 'start a project →'
    },
    
    // Work
    work: {
      heading: 'work',
      intro: 'Selected projects launching Q3 2026.',
      subline: 'Until then — get in touch to discuss yours.',
      categories: {
        residential: {
          title: 'residential',
          subtitle: 'homes with character'
        },
        hospitality: {
          title: 'hospitality',
          subtitle: 'boutique hotels · bars · members clubs · art spaces'
        },
        identity: {
          title: 'visual identity',
          subtitle: 'brand systems for hospitality projects'
        }
      },
      comingSoon: {
        text: 'First projects in this category will be published in Q3 2026.',
        cta: 'If you\'d like to discuss a project —',
        link: 'start the conversation →'
      }
    },
    
    // About
    about: {
      heading: 'about',
      name: 'elena\nmustakova',
      role: 'Founder & Creative Director, Element',
      bio: {
        block1: 'Elena Mustakova trained between Milan and Bulgaria. Bachelor\'s in Design at NABA, Master\'s at Politecnico di Milano. Eight years in Milan — first at art direction studio DO Studio, then as junior interior designer at SAG80, working with the most respected Italian furniture brands.',
        block2: 'Back in Bulgaria, she joined Ligna Group as interior designer — growing into the role of lead designer and key account manager in the hospitality sector. She later co-founded moustache studio in Sofia, leading award-winning hospitality projects: Oborishte 63 (DIBLA, MUSE), Arcus Junior College (DIBLA, Building of the Year shortlist), and an AHEAD London shortlist.',
        block3part1: 'In 2026, she founded Element — her own practice. The decision was simple: it was time to be fully authentic to her vision.',
        block3part2: 'Element designs interior spaces that carry strong emotion. Through context and a clear personal signature, we work with people brave enough to provoke themselves — and developers building the spaces Europe will actually remember.',
        block4: 'Based between Sofia and Milano. Loves her poodle Lori, time in nature, and leaves the country at least once a month.'
      }
    },
    
    // Press
    press: {
      heading: 'press & recognition',
      awards: {
        heading: 'awards',
        attribution: 'Awards earned during prior practice at moustache studio, where Elena served as lead designer.',
        list: [
          { year: '2025', award: 'DIBLA Design Awards', project: 'Arcus Junior College', status: 'Winner' },
          { year: '2025', award: 'Building of the Year', project: 'Arcus Junior College', status: 'Shortlisted' },
          { year: '2023', award: 'DIBLA Design Awards', project: 'Oborishte 63 Boutique Hotel', status: 'Winner' },
          { year: '2023', award: 'AHEAD Awards (London)', project: '—', status: 'Shortlisted' },
          { year: '—', award: 'MUSE Design Award', project: 'Oborishte 63 Boutique Hotel', status: 'Winner' }
        ]
      },
      speaking: {
        heading: 'speaking',
        list: [
          { year: '2025', event: '196+', location: 'Milan, Italy' },
          { year: '2023', event: 'Italian Design Day', location: 'Confindustria Italia' }
        ]
      },
      jury: {
        heading: 'jury positions',
        list: [
          { year: '2025', event: 'Re-branding Bulgaria Design Contest (moustache)', note: 'jury with Domenico Orefice, Ilian Milinov, Maja Lalić, Barry Brand' }
        ]
      },
      closing: 'Selected. Additional features available on request.'
    },
    
    // Contact
    contact: {
      heading: 'contact',
      lead: 'Let\'s talk.',
      email: 'element@mustakova.com',
      phone: '+359 885 826 874',
      instagram: '@element.byelenamustakova',
      instagramUrl: 'https://www.instagram.com/element.byelenamustakova',
      studio: {
        heading: 'Studio · Sofia',
        address1: 'ul. Georgi S. Rakovski 70',
        address2: 'Sofia, Bulgaria'
      },
      also: {
        heading: 'Also based in',
        location: 'Milano, Italy'
      },
      form: {
        name: 'Name',
        email: 'Email',
        project: 'Project · One paragraph is enough.',
        submit: '→ send',
        success: 'Thank you. We\'ll be in touch within two working days.',
        footer: 'For press inquiries — element@mustakova.com with subject "press".'
      }
    },
    
    // Footer
    footer: {
      copyright: '© Element by Elena Mustakova · Sofia · Milano',
      tagline: 'Element by Elena Mustakova — Interior Design Studio, Sofia, Bulgaria'
    }
  },
  
  bg: {
    // Navigation
    nav: {
      work: 'работа',
      about: 'за студиото',
      press: 'публикации',
      contact: 'контакт'
    },
    
    // Home
    home: {
      tagline: 'от елемент към преживяване',
      statement: {
        line1: 'Проектираме за хора, които не се страхуват от пространство с мнение.',
        line2: 'Усещането, което предизвиква — това е дизайнът.',
        line3: 'Всичко останало е изпълнение.',
        line4: 'София · Милано · из цяла Европа.'
      },
      disciplines: {
        residential: 'жилищен дизайн',
        residentialDesc: 'Апартаменти, домове и частни пространства с ясна гледна точка.',
        hospitality: 'дизайн за хотелиерство',
        hospitalityDesc: 'Хотели, ресторанти, барове и офиси, в които хората наистина искат да бъдат.',
        commercial: 'комерсиален дизайн',
        commercialDesc: 'Офиси, шоурумове и търговски пространства, проектирани за хората, които работят и се движат в тях всеки ден.',
        identity: 'визуална идентичност',
        identityDesc: 'Брандови системи, които говорят същия език като пространството.'
      },
      projectIncludes: {
        title: 'Какво включва един проект',
        intro1: 'Работим от първия разговор до последния детайл.',
        intro2: 'Всеки проект — независимо от типа — преминава през пълния процес:',
        services: 'Бриф и концепция · Пространствено планиране · 3D визуализация · Избор на материали, мебели и осветление · Техническа документация · Авторски надзор на обекта',
        closing: 'Без предаване. Без незавършени неща.'
      },
      cta: 'започни проект →'
    },
    
    // Work
    work: {
      heading: 'работа',
      intro: 'Избрани проекти, представени през Q3 2026.',
      subline: 'Дотогава — пишете ни, за да обсъдим вашия.',
      categories: {
        residential: {
          title: 'жилищен дизайн',
          subtitle: 'домове с характер'
        },
        hospitality: {
          title: 'дизайн за хотелиерство',
          subtitle: 'бутикови хотели · барове · мембърс клубове · арт пространства'
        },
        identity: {
          title: 'визуална идентичност',
          subtitle: 'брандинг за хотелиерски проекти'
        }
      },
      comingSoon: {
        text: 'Първите проекти в тази категория ще бъдат публикувани през Q3 2026.',
        cta: 'Ако искате да обсъдим ваш проект —',
        link: 'започнете разговор →'
      }
    },
    
    // About
    about: {
      heading: 'за студиото',
      name: 'елена\nмустакова',
      role: 'Основател и креативен директор, Element',
      bio: {
        block1: 'Елена Мустакова се обучава между Милано и България. Бакалавър по дизайн в NABA, магистър в Politecnico di Milano. Осем години в Милано — първо в студио за арт дирекция DO Studio, по-късно като младши интериорен дизайнер в SAG80, работейки с най-реномираните италиански мебелни брандове.',
        block2: 'Завръща се в България и се присъединява към Ligna Group като интериорен дизайнер — израства до водещ дизайнер и мениджър ключови клиенти в хотелиерския сектор. По-късно е съосновател на moustache studio в София, водейки наградени хотелски проекти: Oborishte 63 (DIBLA, MUSE), Arcus Junior College (DIBLA, шортлист на Building of the Year) и шортлист на AHEAD London.',
        block3part1: 'През 2026 г. основава Element — собствената си практика. Решението е просто: време е да бъде напълно автентична на визията си.',
        block3part2: 'Element проектира интериорни пространства с дълбока емоция. Чрез контекст и ясен личен почерк, работим с хора, които не се страхуват да провокират себе си — и с предприемачи, които градят пространствата, които Европа всъщност ще запомни.',
        block4: 'Базирана между София и Милано. Обича пудела си Лори, времето сред природата и излизането извън страната поне веднъж месечно.'
      }
    },
    
    // Press
    press: {
      heading: 'публикации и отличия',
      awards: {
        heading: 'награди',
        attribution: 'Наградите са получени по време на предходна практика в moustache studio, където Елена е водещ дизайнер.',
        list: [
          { year: '2025', award: 'DIBLA Design Awards', project: 'Arcus Junior College', status: 'Winner' },
          { year: '2025', award: 'Building of the Year', project: 'Arcus Junior College', status: 'Shortlisted' },
          { year: '2023', award: 'DIBLA Design Awards', project: 'Oborishte 63 Boutique Hotel', status: 'Winner' },
          { year: '2023', award: 'AHEAD Awards (London)', project: '—', status: 'Shortlisted' },
          { year: '—', award: 'MUSE Design Award', project: 'Oborishte 63 Boutique Hotel', status: 'Winner' }
        ]
      },
      speaking: {
        heading: 'участия и лекции',
        list: [
          { year: '2025', event: '196+', location: 'Milan, Italy' },
          { year: '2023', event: 'Italian Design Day', location: 'Confindustria Italia' }
        ]
      },
      jury: {
        heading: 'жури',
        list: [
          { year: '2025', event: 'Re-branding Bulgaria Design Contest (moustache)', note: 'jury with Domenico Orefice, Ilian Milinov, Maja Lalić, Barry Brand' }
        ]
      },
      closing: 'Избрани. Допълнителни публикации — при поискване.'
    },
    
    // Contact
    contact: {
      heading: 'контакт',
      lead: 'Нека поговорим.',
      email: 'element@mustakova.com',
      phone: '+359 885 826 874',
      instagram: '@element.byelenamustakova',
      instagramUrl: 'https://www.instagram.com/element.byelenamustakova',
      studio: {
        heading: 'Studio · Sofia',
        address1: 'ul. Georgi S. Rakovski 70',
        address2: 'Sofia, Bulgaria'
      },
      also: {
        heading: 'Also based in',
        location: 'Milano, Italy'
      },
      form: {
        name: 'Име',
        email: 'Имейл',
        project: 'Проект · Един абзац е достатъчен.',
        submit: '→ изпрати',
        success: 'Благодарим. Ще се свържем с вас в рамките на два работни дни.',
        footer: 'За медийни запитвания — element@mustakova.com със заглавие „press".'
      }
    },
    
    // Footer
    footer: {
      copyright: '© Element by Elena Mustakova · София · Милано',
      tagline: 'Element by Elena Mustakova — Interior Design Studio, София, България'
    }
  }
};
